$.validator.addMethod("minDate", function(value, element, param) {
    if (!value) return true;
    return new Date(value) >= new Date(param);
}, "Ingresa una fecha superior a 01-01-1900.");
